
  import { Component, Prop, Vue, Watch ,Inject} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import {
    imgHost
  } from "@/utils/config"
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:''}) modekey!:''
    private imgHost = imgHost
    private imglist:any = []
    private height = 200
    private defaultimg='/image/1677658403671.png'
    private show = true
    private list:any = []
    
    @Inject() information:any
    @Inject() editinfo:any
    get editmsg(){
      return this.editinfo.msg
    }
    get value(){
      let msg = this.information.find(v=>{
        return v.key == this.modekey
      })
      this.imglist = msg.imglist
      // console.log(this.imglist)
      // this.getheight()
      return msg.imglist
    }
    @Watch('imglist',{deep:true})
    private getheightdata(e){
      // console.log(e)
      // this.$nextTick(()=>{
      //   if((this as any).$refs.carousel){
      //     this.list = []
      //     this.list = (this as any).$refs.carousel.map(v=>v.offsetHeight)
      //     // this.$forceUpdate()
      //   }
        this.getheight(true)
      // })
    }
    private getheight(iswatch?:boolean){
      this.list = []
      this.imglist.map(async v=>{
        if(!iswatch){
          v.key = Math.random()+''
        }
        let height = await this.getimgheight(v.url)
        this.list.push(height)
        this.height = Math.max(...this.list)
        return v
      })
    }
    async getimgheight(url){
      let that = this as any
      return new Promise((res)=>{
        var newimage :any = new Image();
        newimage.onload = function(){
          let height = newimage.height/newimage.width*375
          res(height)
        }
        newimage.src = this.imgHost + url
      })
    }
  }
